import { Button, Tooltip } from "@similarweb/ui-components";

import { StyledButtonContainer } from "./styles";

type ConnectionLinkProps = {
    hasAccess: boolean;
    onClick: () => void;
    tooltipContent: string;
    content: string;
};

const ConnectionLink = ({ hasAccess, content, tooltipContent, onClick }: ConnectionLinkProps) => {
    const button = (
        <StyledButtonContainer>
            <Button
                type="flat"
                isDisabled={!hasAccess}
                onClick={onClick}
            >
                {content}
            </Button>
        </StyledButtonContainer>
    );
    if (!hasAccess) {
        return <Tooltip content={tooltipContent}>{button}</Tooltip>;
    }

    return button;
};

export default ConnectionLink;
